import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { AwsSmAccesses } from "./accesses.ts";
import { AwsSmComponents } from "./components.ts";

const AwsSmFilters = {} as const satisfies AnyFilterSchema;
export type AwsSmFilters = typeof AwsSmFilters;

export const AwsSmRegistration = Registration({
  accesses: AwsSmAccesses,
  category: "resource",
  components: AwsSmComponents,
  docs: { install: "aws-secrets-manager" },
  filters: AwsSmFilters,
  itemKind: "Account",
  label: "AWS Secrets Manager",
  logoUrl:
    "https://awsfundamentals.com/assets/aws-icons/Arch_AWS-Secrets-Manager_64.svg",
  maturity: "preview",
  requestType: "bridge",
  useMapping: [
    { use: "iam_write", component: "iam-write" },
    { use: "identity", component: "iam-write" },
  ],
});

registerIntegration("aws-sm", AwsSmRegistration);
